import { Box, Button, Drawer, Flex, Text } from "@mantine/core";
import useStyles from "./style";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ViewInvoiceDrawer = ({ drawerOpened, drawerClose, upcomingInvoice }) => {
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const { classes, cx } = useStyles();

  const handleCancel = () => {
    drawerClose();
  };

   const handleDownloadPDF = async () => {
    // Create a hidden div for PDF content
    const pdfContent = document.createElement("div");
    pdfContent.style.padding = "20px";
    pdfContent.style.fontFamily = "Inter";
    pdfContent.innerHTML = `
      <h2>Invoice Summary</h2>
      <p><strong>Billing To:</strong> ${profile?.user?.name }</p>
      <p><strong>Plan:</strong> $${upcomingInvoice?.nextPayment} / ${upcomingInvoice?.duration}</p>
      <p><strong>Status:</strong> Upcoming</p>
    `;
    document.body.appendChild(pdfContent);

    // Convert HTML to canvas
    const canvas = await html2canvas(pdfContent, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    // Create PDF
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("invoice.pdf");

    // Remove temporary div
    document.body.removeChild(pdfContent);
  };

  return (
    <Drawer
      opened={drawerOpened}
      offset={8}
      size="55%"
      sx={{
        ".mantine-Drawer-close": {
          color: "#000",
          "& svg": {
            width: "25px !important",
            height: "25px !important",
          },
        },
        ".mantine-11shxvp": {
          background: "#F5F5F5",
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
        },
        ".mantine-Drawer-close:hover": {
          color: "#FFAF4A",
        },
        ".mantine-1q36a81": {
          padding: "15px 29px !important",
        },
      }}
      zIndex={1000}
      title={
        <Text fz={24} fw={700} ff="Inter" color="#000">
          Invoice
        </Text>
      }
      position="right"
      overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
      shadow="md"
      onClose={handleCancel}
      centered
    >
      <Box className={classes.contentBox}>
        <Box className={classes.summaryBox}>
          <h6 className={classes.summaryHdng}>Invoice Summary</h6>
          <Flex className={classes.summaryInfoParent}>
            {/* <Flex gap={4}>
              <p className={classes.infoLabel}>Invoice #:</p>
              <p className={classes.infoValue}>INV-2025-1005</p>
            </Flex> */}
            <Flex gap={4}>
              <p className={classes.infoLabel}>Billing To:</p>
              <p className={classes.infoValue}>{profile?.user?.name}</p>
            </Flex>
            <Flex gap={4}>
              <p className={classes.infoLabel}>Plan:</p>
              <p className={classes.infoValue}>
                ${upcomingInvoice?.nextPayment}/{upcomingInvoice?.duration}
              </p>
            </Flex>
            <Flex gap={4}>
              <p className={classes.infoLabel}>Status:</p>
              <p className={classes.infoValue}>Upcoming</p>
            </Flex>
          </Flex>
          <Button className={classes.downloadPdfBtn} onClick={handleDownloadPDF}>Download PDF</Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ViewInvoiceDrawer;
